module.exports = __webpack_public_path__ + "static/media/1.eaa1804a.jpg";